<div class="save-filter__item"
     dropDown
     [class.disabled]="!canSave"
     [optionsTemplate]="saveFilterTemplate"
     [title]="canSave ? 'dashboard.filter.selectSaveMethod' : 'dashboard.filter.addDefaultMeasures' | i18next" 
>
    <i class="icn icn-save"></i>
    <div class="save-filter__not-saved-dot" *ngIf="!isSaved() && canSave"></div>
    <div class="save-filter__not-saved-dot warning" *ngIf="!canSave"></div>
</div>
<div class="save-filter_info" *ngIf="!isSaved() && canSave">
    {{'analytics.reports.notSaved' | i18next}}
</div>

<ng-template #saveFilterTemplate>
    <div class="save-filter__select-container" *ngIf="!openedModal">
        <h6 class="title-h6">{{'dashboard.filter.selectSaveMethod'| i18next}}</h6>
        <div class="save-filter__select" *ngIf="canSave">
            <div class="save-filter__select-item" (click)="openOverwrite()" *ngIf="canOverwrite">{{'dashboard.filter.save'| i18next}}</div>
            <div class="save-filter__select-item" (click)="openSaveAsModel()">{{'dashboard.filter.saveAs'| i18next}}</div>
            <div class="save-filter__select-item" (click)="openRenameModal()" *ngIf="canOverwrite">{{'dashboard.filter.rename'| i18next}}</div>
        </div>
        <div class="save-filter__select-info" *ngIf="!canSave">
            {{'dashboard.filter.addMinFilters' | i18next}}
        </div>
    </div>
    <form class="save-filter__modal" [formGroup]="form" (ngSubmit)="onSubmit($event)" *ngIf="openedModal === modalStates.SAVE_AS" [class.loading]="loading$ | async">
        <h6 class="title-h6">{{'dashboard.filter.saveFilters'| i18next}}</h6>
        <form-errors [top]="false"></form-errors>

        <div class="save-filter__modal-wrap">
            <input type="text"
                   id="save-filter__name"
                   formControlName="name"
                   autoComplete="false"
                   class="input save-filter__input"
                   placeholder="Report name"
            />
            <input-errors-tooltip [control]="form.get('name')"></input-errors-tooltip>

            <inline-select class="save-filter__select"
                           formControlName="activityFilter"
                           [typeDate]="activityDate"
                           *ngIf="hasDate(activityDate)"
            >
                <ng-container *ngFor="let item of filterPeriodsType">
                    <list-option [value]="item"
                                 [label]="item === 'EXACT_DATES'
                                          ? getDate(activityDate)
                                          : 'dashboard.filter.saveFilterPeriods.' + item | i18next"
                    ></list-option>
                </ng-container>
            </inline-select>

            <inline-select class="save-filter__select"
                           formControlName="installFilter"
                           [typeDate]="installDate"
                           *ngIf="hasDate(installDate)"
            >
                <ng-container *ngFor="let item of filterPeriodsType">
                    <list-option [value]="item"
                                 [label]="item === 'EXACT_DATES'
                                          ? getDate(installDate)
                                          : 'dashboard.filter.saveFilterPeriods.' + item | i18next"
                    ></list-option>
                </ng-container>
            </inline-select>
            <checkbox
                    formControlName="isDefault"
                    class="save-filter__checkbox"
            >
                {{ "analytics.reports.setAsDefault" | i18next }}
            </checkbox>
            <div class="save-filter__btns">
                <button class="button button--small button--primary-inverted"
                        (click)="onSubmit($event)"
                        [class.loading]="formService.pending$ | async"
                >
                    {{'common.btn.save'| i18next}}
                </button>
                <button class="button button--small button--cancel"
                        [class.shake]="shakeButton"
                        (click)="cancelSaveFilterTemplate($event)"
                >
                    {{'common.btn.cancel'| i18next}}
                </button>
            </div>
        </div>
    </form>

    <div class="save-filter__modal" *ngIf="openedModal === modalStates.OVERWRITE" [class.loading]="loading$ | async">
        <h6 class="title-h6">{{'dashboard.filter.saveFilters'| i18next}}</h6>

        <div class="save-filter__modal-wrap">
            <div>{{'dashboard.filter.overwrite'| i18next}}</div>

            <div class="save-filter__btns">
                <button class="button button--small button--primary-inverted"
                        (click)="onOverwrite($event)"
                        [class.loading]="formService.pending$ | async"
                >
                    {{'common.btn.save'| i18next}}
                </button>
                <button class="button button--small button--cancel"
                        [class.shake]="shakeButton"
                        (click)="cancelSaveFilterTemplate($event)"
                >
                    {{'common.btn.cancel'| i18next}}
                </button>
            </div>
        </div>
    </div>

    <div>
        <form class="save-filter__modal" [formGroup]="renameForm" (ngSubmit)="onRename($event)" *ngIf="openedModal === modalStates.RENAME" [class.loading]="loading$ | async">
            <h6 class="title-h6">{{'dashboard.filter.renameAs'| i18next}}</h6>
            <form-errors [top]="false"></form-errors>
    
            <div class="save-filter__modal-wrap">
                <input type="text"
                       id="save-filter__name"
                       formControlName="name"
                       autoComplete="false"
                       class="input save-filter__input"
                       placeholder="{{'dashboard.filter.name'| i18next}}"
                />
                <input-errors-tooltip [control]="form.get('name')"></input-errors-tooltip>
    
                <div class="save-filter__btns">
                    <button class="button button--small button--primary-inverted"
                            (click)="onRename($event)"
                            [class.loading]="formService.pending$ | async"
                    >
                        {{'common.btn.save'| i18next}}
                    </button>
                    <button class="button button--small button--cancel"
                            [class.shake]="shakeButton"
                            (click)="cancelSaveFilterTemplate($event)"
                    >
                        {{'common.btn.cancel'| i18next}}
                    </button>
                </div>
            </div>
        </form>
    </div>
        

    <div class="save-filter__modal-overlay" (click)="shakeCancel($event)"></div>
</ng-template>
